import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import BFormWrapper from "../../forms/BFormWrapper";
import BSpinner from "../spinners/BSpinner";

export default function BAddPage({
  name,
  service,
  redirectAfterSubmit = false,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [addAnother, setAddAnother] = useState(!redirectAfterSubmit);
  const history = useHistory();

  const tryAdd = (formData) => {
    setIsLoading(true);
    setErrors([]);
    setSuccess(false);
    
    service
      .add(formData)
      .then(() => {
        setSuccess(true);

        if (!addAnother) {
          history.push(`/${name}`);
        }
      })
      .catch((err) => {
        setSuccess(false);

        if (err.response) {
          setErrors(err.response.data);
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      {isLoading && <BSpinner />}
      {!isLoading && (
        <div className="m-6 bg-white border-gray-400 rounded shadow-md relative">
          <BFormWrapper
            name={name}
            onSubmit={tryAdd}
            responseErrors={errors}
            success={success}
          />
          <label className="absolute flex items-center text-l mt-3 pb-6">
            <input
              value={addAnother}
              onChange={() => setAddAnother((prev) => !prev)}
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
            />
            <span className="ml-2 text-gray-700">Add Another</span>
          </label>
        </div>
      )}
    </>
  );
}
